import { useState } from 'react';
import { useJournalStore } from '../hooks/useJournalStore';
import { continuationApi } from '../services/api';
import type { WidgetProps } from './WidgetRegistry';

export function AnnotationInputWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  const loadJournal = useJournalStore((s) => s.loadJournal);
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);

  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const rootId = journal.rootContinuation.id;

  async function sendAnnotation() {
    if (!content.trim()) return;
    setSending(true);
    try {
      await continuationApi.annotate(rootId, content.trim());
      setContent('');
      await loadJournal(rootId);
    } catch (err) {
      console.error('Annotation failed:', err);
    } finally {
      setSending(false);
    }
  }

  async function sendSignal(type: 'approve' | 'kill') {
    setSending(true);
    try {
      await continuationApi.signal(rootId, type, content || undefined);
      setContent('');
      await loadJournal(rootId);
    } catch (err) {
      console.error('Signal failed:', err);
    } finally {
      setSending(false);
    }
  }

  return (
    <div className="p-3 flex flex-col h-full">
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Add a note, correction, or instruction..."
        className="flex-1 bg-tower-bg border border-tower-border rounded p-2 text-sm text-tower-text resize-none focus:outline-none focus:border-tower-accent"
      />
      <div className="flex gap-2 mt-2">
        <button
          onClick={sendAnnotation}
          disabled={sending || !content.trim()}
          className="px-3 py-1.5 bg-tower-accent text-textOnPrimary text-xs rounded hover:bg-tower-accent/80 disabled:opacity-40"
        >
          Annotate
        </button>
        <button
          onClick={() => sendSignal('approve')}
          disabled={sending}
          className="px-3 py-1.5 bg-tower-success/20 text-tower-success text-xs rounded hover:bg-tower-success/30 disabled:opacity-40"
        >
          Approve
        </button>
        <button
          onClick={() => sendSignal('kill')}
          disabled={sending}
          className="px-3 py-1.5 bg-tower-danger/20 text-tower-danger text-xs rounded hover:bg-tower-danger/30 disabled:opacity-40"
        >
          Kill
        </button>
      </div>
    </div>
  );
}
